export type CookieRow = {
  host: string;
  cookies: string[];
};

export const CookieSettingsButton = () => (
  <button
    type="button"
    onClick={() => {}}
    data-color="accent"
    className="button-filled mt-32 optanon-toggle-display"
  >
    Change cookie settings
  </button>
);

const CookieTable: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <table className="w-full" style={{ tableLayout: 'fixed' }}>
    <thead>
      <tr className="text-secondary">
        <th className="p-16 border-b">
          <p className="font-20 font-light text-start">Host</p>
        </th>
        <th className="p-16 border-b">
          <p className="font-20 font-light text-start">Cookies (Lifespan)</p>
        </th>
      </tr>
    </thead>
    <tbody>{children}</tbody>
  </table>
);

export const CookieSection: React.FC<{
  data: CookieRow[];
}> = ({ data }) => (
  <CookieTable>
    {data.map((item) => (
      <tr key={item.host} className="text-secondary">
        <td className="border-b p-16">
          <p>{item.host}</p>
        </td>
        <td className="border-b border-l p-16">
          {item.cookies.map((cookie) => (
            <p key={cookie}>{cookie}</p>
          ))}
        </td>
      </tr>
    ))}
  </CookieTable>
);
